import { all } from 'redux-saga/effects';
import FormsSaga from 'circe/forms/saga';
import OrderSaga from 'domain/order/saga';

import AuthenticationSaga from 'circe/authentication/saga';
import FuseAuthorizationSaga from 'domain/fuse/auth/saga';
import ProfilesAuthSaga from 'domain/fuse/auth/profiles/saga';

import OperationsSaga from 'domain/operations/saga';
import OperationsDashboardSaga from 'domain/operations/dashboard/saga';
import ShipperSaga from 'domain/shipper/saga';

import AccountManagementSaga from 'domain/operations/accountManagement/saga';
import ShipmentSaga from 'domain/shipment/saga';
import PaymentsSaga from 'domain/payment/saga';
import FinanceSaga from 'domain/finance/saga';
import FirebaseSaga from 'domain/fuse/firebase/saga';
import AddressSage from 'domain/addressBook/saga';
import BatchSaga from 'domain/batch/saga';
import ListingSaga from 'circe/queryListing/saga';

import PreferencesSaga from 'domain/fuse/preferences/saga';

import ManifestSaga from 'domain/manifest/saga';
import SingleSaga from 'domain/fuse/single/saga';
import CarriersSaga from 'domain/carriers/saga';
import AccountAdminsSaga from 'domain/accountAdmins/saga';
import WaybillDocScanSaga from 'domain/waybillDocScan/saga';

import VehicleSage from 'domain/vehicle/saga';
import ProductTypeSaga from 'domain/productType/saga';
import stockUnitSaga from 'domain/stockUnit/saga';
import SubmitSaga from 'domain/fuse/submit/saga';
import { errorHandler } from './middlewares';

function* rootSaga(context) {
  try {
    yield all([
      AddressSage(context),
      AuthenticationSaga(context),
      WaybillDocScanSaga(context),
      ProfilesAuthSaga(),
      FormsSaga(),
      CarriersSaga(context),
      OrderSaga(context),
      FuseAuthorizationSaga(context),
      FirebaseSaga(context),
      OperationsSaga(context),
      AccountManagementSaga(),
      ShipmentSaga(context),
      PaymentsSaga(context),
      FinanceSaga(context),
      ShipperSaga(context),
      OperationsDashboardSaga(context),
      ListingSaga(context),
      BatchSaga(context),
      PreferencesSaga(),
      ManifestSaga(context),
      SingleSaga(context),
      SubmitSaga(context),
      VehicleSage(context),
      AccountAdminsSaga(context),
      stockUnitSaga(context),
      ProductTypeSaga(context),
    ]);
  } catch (e) {
    errorHandler(e);
  }
}

export default rootSaga;
